/**
 * Returns true if the browser is Edge before it switched to Chromium.
 * @see https://superuser.com/questions/1552847/what-version-of-edge-marked-the-start-of-using-chromium-internally#answer-1552859
 */
function isLegacyEdge() {
  return navigator.userAgent.indexOf('Edge/') > -1;
}

/**
 * Provides access to a form of browser storage.  localStorage if available, otherwise sessionStorage.  Allows support
 * for browsers with localStorage disabled and in a form that is easily mocked.
 */
export function getStorageSafely() {
  try {
    // IE throws an error if you try and access localStorage and its disabled. #@$#%!!
    if (window.localStorage) {
      // Edge before chromium doesn't seem to keep localStorage synchronized
      // across tabs unless an `onstorage` handler is assigned #@$#%!!
      // REF: https://stackoverflow.com/a/42377129
      if (isLegacyEdge()) {
        window.onstorage = function () {};
      }
      return window.localStorage;
    } else {
      return window.sessionStorage;
    }
  } catch (e) {
    return window.sessionStorage;
  }
}
